/**
 * Uppercase the region segment of a BCP-47 locale string.
 * @example capitalizeLanguageRegion('en-us') === 'en-US'
 */
export const capitalizeLanguageRegion = (locale: string): string => {
  if (locale && locale.indexOf("-") > 0) {
    const parts = locale.split("-");
    if (parts.length === 2) return `${parts[0]}-${parts[1].toUpperCase()}`;
  }
  return locale;
};
